module.exports = __webpack_public_path__ + "img/introduce-4.00abc335.png";